import { VisitMedicalInformation } from '@dreryk/egabinet-visit-frontend-api';

import { StyledFlex, TestableComponentProps } from '@dreryk/react-components';

import { VisitHistoryOtherExaminationItem } from './VisitHistoryOtherExaminationItem';

type VisitOtherExaminationsSectionProps = TestableComponentProps & {
   readonly visitMedicalInformationList: VisitMedicalInformation[];
};

export const VisitHistoryOtherExaminationsSection = (props: VisitOtherExaminationsSectionProps): JSX.Element => {
   const { visitMedicalInformationList } = props;

   return (
      <StyledFlex direction={'column'} gap={12}>
         {visitMedicalInformationList.map((visitMedicalInformation) => (
            <VisitHistoryOtherExaminationItem
               key={visitMedicalInformation.medicalInformationId}
               visitMedicalInformation={visitMedicalInformation}
            />
         ))}
      </StyledFlex>
   );
};
